export default {
    signIn_signIn_title: "Вход",
    signIn_enter: "Войдите, используя",
    signIn_or: "или",
    signIn_difficulties: "Возникли трудности?",
    signIn_contact: "Свяжитесь с нами по адресу",
    signIn_signUp_title: "Регистрация",
    signIn_enter_using_email: "или войдите, используя email",
    signIn_email_hint: "Email",
    signIn_password_hint: "Пароль",
    signIn_signInBtn: "Войти",
    signIn_forgotPass_btn: "Забыли пароль?",
    signIn_noCreditReq: "Платежные данные не требуются",
    signIn_firstName_hint: "Имя",
    signIn_lastName_hint: "Фамилия",
    signIn_signUp_btn: "Создать аккаунт",
    signIn_useMedia: "Или зарегистрируйтесь через соцсети",
    signIn_agreeTo: "Я принимаю",
    signIn_tAndC: "Условия пользования",
    signIn_recoverPassword: "Восстановление пароля",
    signIn_recoverPassSubtitle: "Введите email, который был использован при регистрации",
    signIn_recoverPassContinue: "Продолжить",
    signIn_recoverPassBack: "На страницу входа",
    signIn_protected: "Этот сайт защищен reCAPTCHA и применяются",
    signIn_privacyPolice: "Политика Конфиденциальности",
    signIn_and: "и",
    signIn_Terms: "Условия использования",
    signIn_Login: "Войти через {v1}",
    signIn_Register: "Регистрация через {v1}",
    signIn_RegisterWithEmail: "Зарегистрируйтесь с помощью электронной почты",
    signIn_RegisterWithQuestion: "Далее: О моем бизнесе",
    signIn_SeparatorText: "ИЛИ",
    signIn_TitleWithQuestion: "Зарегистрируйтесь в AirVote, чтобы:",
    signIn_ChecklistFirst: "Получить QR-смайлики по электронной почте",
    signIn_ChecklistSecond: "Получить доступ к панели вашего бизнеса и отслеживать отзывы",
    profilePosition: "Персонал",
    password_validation_min_length: "Минимум 6 символов",
    password_validation_uppercase: "Одна заглавная буква",
    password_validation_lowercase: "Одна строчная буква",
    ambassadorBtn_title: 'Станьте амбасадором J-Bar',
    ambassadorBtn_subtitle: "Отзывы = Награды",
    ambassadorPopup_title: "Чтобы стать амбасадором J-Bar, вам необходимо:",
    ambassadorPopup_votes: "20 AirVotes",
    ambassadorPopup_review: "Відгук Google або Facebook",
    giveawayPopup_entered: "Вы будете участвовать в розыгрыше",
    ambassadorPopup_BtnLogin: "Начните с авторизации",
    giveawayPopup_BtnReview: 'Оставить отзыв',
    ambassadorPopup_cancel: 'Нет спасибо',
    ambassadorFinishTitle: "Преимущества J-Bar Амбассадор",
    ambassadorMonthlyDrawing: "Каждый AirVote голос участвует в ежемесячном розыгрыше 100 долларов США",
    ambassadorReceive: "Амбасадоры получат дополнительные подарки и признание!",
    ambassadorHelpUsTogether: "Помогите нам добиться успеха вместе!",
    giveawayPopup_finalStep: 'Мы ценим ваш честный отзыв!\n\nВы были добавлены в наш розыгрыш.\n\nВернитесь и проголосуйте еще раз: каждый голос увеличивает ваши шансы!',
    giveawayPopup_proceedReview: "Перейти к отправке отзыва",
    Thank_for_vote: "Спасибо за Ваш голос. Желаете посмотреть Ваши оценки? Войдите при помощи",
    thankVoteTitle1: "Отзыв сохранен",
    thankVoteTitle2_1: "Спасибо за ваш отзыв",
    thankVoteTitle2_2: "Зарегистрируйтесь в AirVote, чтобы просматривать и изменять свои голоса",
    writeFeedBack: "Оставить отзыв (опционально)",
    voteSuccessText_1: "Cпасибо, Ваш голос отправлен!",
    voteSuccessText_2: "Хотите изменить голос? Нажмите на другой смайлик.",
    voteSuccessText_3: "Есть что сказать? Можете оставить отзыв",
    feedbackTitle: "Оставьте свой отзыв",
    feedbackTitleSoSo: "Что стоит улучшить?",
    feedbackTitleSad: "Подскажите, что не так?",
    feedbackTextRating: 'Почему вы поставили этому спикеру такую оценку?',
    yourNote: "Ваш коментарий",
    addYourNote: "Добавьте комментарий",
    commentPopupEmail: "Введите email или номер телефона",
    feedbackText: "Свяжитесь со мной",
    feedbackTextServiceLog: "Контактные данные",
    feedbackTextOr: "или",
    writeAReview: "Публичный отзыв",
    writeAReviewTitle: "Вы можете оставить отзыв для {v1} тут:",
    Logout: "Выход",
    Sync_status: "Статус синхронизации",
    Close: "Закрыть",
    OK: "OK",
    title_404: "Страница, на которую вы пытаетесь перейти, недоступна",
    btn_404: "Назад",
    Cancel: "Отмена",
    Submit: "Отправить комментарий",
    reviewSocial: "О нас",
    reviewSocialOr: "Подробнее о нас",
    anonComment: "Анонимный комментарий",
    powered_by: "Powered by AirVote\nGet it for your business",
    UploadNewPhoto: "Загрузить новое фото",
    RemovePhoto: "Удалить фото",
    WrongFormat: "Неверный формат. Поддерживаются PNG или JPG",
    PhotoOverweight: "Фотография больше чем {v1}Мб",
    max_attach_photos_count_error: "Максимальное кол-во файлов - {v1}",
    ambassadorDescription: "Каждый AirVote отзыв добавляет вас в ежемесячный розыгрыш 100 долларов США (ограничение 1 на каждое место в день).\n" +
        "Амбасадоры получат дополнительные награды и признание!\n" +
        "\n" + "Помогите нам добиться успеха вместе!",
    Placement: "Местоположение",
    Update: "Обновить",
    NewPlacementSaved: "Новое местоположение успешно сохранено",
    PleaseEnterCorrectPlacement: "Пожалуйста, введите правильное местоположение",
    manageGPSAllowTitle: "Хотите поделиться своим местоположением ?",
    manageGPSAllowText: "Знание точного местоположения проблемы помогает нам быстрее ее исправить. Мы не будем отслеживать ваше местоположение или передавать его кому-либо за пределами нашей сервисной службы",
    manageGPSAllowOKButton: "ОК поделиться",
    manageGPSAllowCancelButton: 'Предпочитаю не делиться',
    level2_notp: "Нет бумаги",
    level2_full: "Заполненный",
    level2_dirty: "Грязно",
    level2_smells: "Воняет",
    level2_broken: "Сломано",
    level2_otherl: "Другое",
    level2_nopaper: "Нет полотенец",
    level2_title: "Выполненные услуги",
    level2_maxCount: "Максимальное количество для выбора: {v1}",
    need_audio_permission_error: "Пожалуйста, разрешите доступ к микрофону для записи аудио",
    play_dino: "Играть",
    dino_play_btn: "Играть",
    dino_jump_btn: "Прыжок",
    dino_down_btn: "Присесть",
    vote_screen_public_review_popup_title: "Оставьте отзыв в соцсетях",
    QR_smiley_disabled: "Этот QR-смайлик был отключен.\nПожалуйста, обратитесь напрямую к руководству.",
    QR_smiley_disabled_links: "Есть вопросы о AirVote®?\nПерейдите на {v1} или напишите нам по адресу {v2}.",
    QR_smiley_disabled_footer: "Благодарим вас за предоставленный отзыв!",
    sl_final_Title1: "Service log saved!",
    serviceLogInfoBtn: "История обслуживания",
    noServiceLogs: "Журнал обслуживания пуст",
    snapPicturePopupTitle: "Подтвердите свой отзыв фотографией уборной",
    snapPictureButton: "Сделать снимок",
    snapPicturePopupContinue: "Продолжить",
    subtitleDefault: "Будем рады, если вы отправите фото проблемы",
    signIn_Pin: "Войти, используя ПИН",
}
